import { RawUserPersonalInfoModel } from "../user_personal_info_model.js";

class RawAdminUserIdentityInfoModel extends RawUserPersonalInfoModel {

  formFieldsWhitelist(item=undefined) {
    return ["citizenship", "title", "hasUsTaxLiability", "politicallyExposed", "taxId"]
  }

}
const AdminUserIdentityInfoModel = new RawAdminUserIdentityInfoModel();

export { RawAdminUserIdentityInfoModel, AdminUserIdentityInfoModel }
